import {
  type Currency,
  type CurrencyId,
  UNKNOWN_CURRENCY,
} from "@anaconda/core/price/types"
import { useSuspenseQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { CurrencyMoleculeReatom as CurrencyMolecule } from "./index.reatom"

export const useCurrency = (currencyId?: CurrencyId) => {
  const { allCurrenciesQueryParamsAtom } = useMolecule(CurrencyMolecule)
  const queryParams = allCurrenciesQueryParamsAtom()
  const { data: currencies } = useSuspenseQuery<Currency[]>(queryParams)

  return (
    currencies.find((currency) => currency.id === currencyId) ??
    UNKNOWN_CURRENCY
  )
}

export const useCurrencyPrice = (currencyId: CurrencyId) => {
  const currency = useCurrency(currencyId)

  return currency?.usdExchangeRate
}
